import {
  Button,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MaterialTable from "material-table";
import { useHistory } from "react-router-dom";
import LabelsContext from "../../../lang/LabelsContext";
import EnumGroup from "../../../utils/enum/EnumGroup";
import HtmlTooltip from "../../system/html-tooltip/HtmlTooltip";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import AddReviewer from "../add-reviewer/AddReviewer";
import { usersTitle } from "../manuscript/submit/TooltipText";
import UsersService, { UsersServiceType } from "./UsersService";
import useStyles from "./UsersStyle";

export default function Users() {
  const { Labels } = LabelsContext();
  const classes = useStyles();
  const history = useHistory();
  const {
    users,
    groups,
    saveReviewer,
    loginAs,
    changeGroupDialog,
    setChangeGroupDialog,
    changeGroup,
    authData,
  }: UsersServiceType = UsersService();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        data={users}
        icons={tableIcons}
        columns={[
          { field: "id", title: "ID", hidden: true },
          { field: "firstName", title: Labels.FIRSTNAME },
          { field: "lastName", title: Labels.LASTNAME },
          { field: "email", title: Labels.EMAIL_ADDRESS },
          { field: "orcid", title: Labels.ORCID },
          { field: "country", title: Labels.COUNTRY },
          { field: "group.group", title: "Group" },
          {
            field: "changeGroup",
            sorting: false,
            hidden: ![EnumGroup.EDITOR, EnumGroup.ASSISTANT, EnumGroup.ASSOCIATE_EDITOR].includes(
              authData?.user.group.group
            ),
            title: "",
            cellStyle: { width: "20%" },
            render: (rowData) => {
              if (
                [EnumGroup.ASSISTANT, EnumGroup.EDITOR, EnumGroup.ASSOCIATE_EDITOR].includes(rowData?.group?.group) &&
                authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR
              ) {
                return null;
              }

              return (
                <Button variant="contained" onClick={() => setChangeGroupDialog(rowData)} color="primary">
                  {Labels.CHANGE_GROUP}
                </Button>
              );
            },
          },
          {
            field: "details",
            sorting: false,
            title: "",
            cellStyle: { width: "7%" },
            render: (rowData) => {
              if (
                [EnumGroup.ASSISTANT, EnumGroup.EDITOR].includes(rowData?.group?.group) &&
                authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR
              ) {
                return null;
              }

              return (
                <Button variant="contained" onClick={() => history.push(`/user/edit/${rowData.id}`)} color="primary">
                  {Labels.EDIT}
                </Button>
              );
            },
          },
          {
            field: "login",
            sorting: false,
            title: "",
            cellStyle: { width: "11%" },
            render: (rowData: any) => {
              if (
                [EnumGroup.ASSISTANT, EnumGroup.EDITOR].includes(rowData?.group?.group) &&
                authData?.user.group.group === EnumGroup.ASSOCIATE_EDITOR
              ) {
                return null;
              }
              return (
                <Button variant="contained" onClick={() => loginAs(rowData.id)} color="primary">
                  {Labels.LOGIN_AS}
                </Button>
              );
            },
          },
        ]}
        title={
          <div className={classes.addReviewerContainer}>
            <Grid container justify="space-evenly">
              <Typography variant="h5">{Labels.USERS}</Typography>
              <HtmlTooltip title={usersTitle}>
                <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
              </HtmlTooltip>
            </Grid>
            <AddReviewer save={saveReviewer} label={Labels.ADD_REVIEWER} />
          </div>
        }
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
          pageSizeOptions: [10, 50, 100, users?.length > 100 ? users.length : 1000],
        }}
      />
      <Dialog
        maxWidth={"md"}
        open={changeGroupDialog !== undefined}
        onClose={() => setChangeGroupDialog(undefined)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">{Labels.CHANGE_GROUP}</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={groups}
            value={changeGroupDialog?.group ?? undefined}
            onChange={(event, newValue) => {
              setChangeGroupDialog({
                ...changeGroupDialog,
                group: newValue,
              });
            }}
            disableClearable={true}
            getOptionLabel={(option: any) => option.group}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                margin="normal"
                id="group"
                name="group"
                label={Labels.GROUPS}
                fullWidth
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setChangeGroupDialog(undefined)} color="primary">
            {Labels.CANCEL}
          </Button>
          <Button onClick={changeGroup} color="primary" variant="contained">
            {Labels.CHANGE_GROUP}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
